import { LandingIcon } from '@/assets';

export const socialMediaData = [
  {
    name: 'WhatsApp',
    icon: LandingIcon.whatsapp,
    link: 'https://wa.me/1234567890',
  },
  {
    name: 'Instagram',
    icon: LandingIcon.instagram,
    link: 'https://instagram.com/company/smartturn',
  },
  {
    name: 'Facebook',
    icon: LandingIcon.facebook,
    link: 'https://www.facebook.com/profile.php?id=100085219720017',
  },
  {
    name: 'LinkedIn',
    icon: LandingIcon.linkedin,
    link: 'https://www.linkedin.com/company/smart-turn/',
  },
];

// Passcode verification session management constants (15 minutes)
export const PASSCODE_SESSION_KEY = 'member_field_edit_passcode_session';
export const PASSCODE_SESSION_DURATION = 15 * 60 * 1000;
